import { Observable, of } from "rxjs";
import { Cache } from "@webapp/core/state-management/models/cache.model";

export class TimeoutCache<T> implements Cache<T> {
  private cache: T;
  private cacheTimestamp: number = Date.now();

  constructor(private options: { timeout: number }) {}

  public get$(): Observable<T> {
    if (this.isCacheTimedout()) {
      return of(undefined);
    }

    return of(this.cache);
  }

  public set(value: T): void {
    this.cacheTimestamp = Date.now();
    this.cache = value;
  }

  public hasValue(): boolean {
    return !!this.cache;
  }

  private isCacheTimedout(): boolean {
    return Date.now() - this.cacheTimestamp > this.options.timeout;
  }
}
